import React from 'react';

function Messages(){

    return (
       
        <>
          
          <div class="card p-3 mb-2">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        <span class="material-symbols-rounded">chat</span>
                         </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Messages</h6>{/* <span>Pending Ticket Approval</span> */}
                        </div>
                    </div>
                    {/* 
                    <div class="badge Process"> <span>Open</span> </div>
                    */}
                </div>
                <div class="mt-3">

                <div className='message'>
            <span className="smallInfo "><strong className=' Process'><span>Admin</span></strong>
            Gridvolt will provide a site attendance date for remote firmware update.

-I will follow up to find out when are they planning to visit the site
<hr style={{border: "1px solid #d0e9ef"}} />
<strong className=' Process'><span>You</span></strong>
             Attendance date for remote firmware update.

             find out when are they planning to I will follow up to visit the site


            </span>
            </div>



<span style={{display:"flex"}}>
                     <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Send a Message"
            style={{ marginTop: "20px", width:"100%", paddingRight:"50px" }}
            />


<span onClick={""} style={{height:"100%" , margin: "0px",  paddingTop:"0px", fontSize:"12px", paddingLeft:"10px", marginTop:"24px", marginLeft:"-50px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"7px"}} >send</span> </span>

</span>
            

                </div>
            </div>

        </>
    )
}

export default Messages;






















